<form *ngIf="!this.loading" [formGroup]="editForm">
  <div class="form-group form-floating mb-3">
    <div class="form-floating mb-4" [appValidateState]="editForm.get('title')">
      <div class="text-[11.5px] font-medium text-slate-700">
        {{ "name" | transloco }}
      </div>
      <input
        id="title"
        formControlName="title"
        type="text"
        class="w-full text-[12.5px] text-slate-800 bg-slate-50 border border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:border-slate-400"
        placeholder="{{ 'name' | transloco }}"
        autocomplete="off"
      />
    </div>
    <div class="inpt-title mt-3">{{ "checklist" | transloco }}:</div>
    <div formArrayName="items">
      <button
        class="px-2.5 py-1.5 rounded-lg bg-slate-900 text-white text-[12px] font-medium"
        icon="pi pi-plus"
        (click)="addChecklistItem()"
      >
        {{ "add" | transloco }}
      </button>
      <div
        *ngFor="let chl of checkListItemFormArray.controls; let i = index"
        [formGroupName]="i"
        class="d-flex align-items-center gap-2 mb-2"
      >
        <input
          type="text"
          formControlName="title"
          class="w-full text-[12.5px] text-slate-800 bg-slate-50 border border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:border-slate-400"
          placeholder="{{ 'title' | transloco }}"
        />
        <button
          mat-icon-button
          class="text-danger"
          (click)="removeChecklistItem(i)"
        >
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
    <div class="d-flex gap-2 mt-4">
      <button
        type="button"
        class="w-100 px-2.5 py-1.5 rounded-lg bg-slate-900 text-white text-[12px] font-medium"
        (click)="onSubmit()"
        [disabled]="editForm.invalid"
      >
        {{ "save" | transloco }}
      </button>
    </div>
  </div>
</form>
